import { render } from "./WebView.vue?vue&type=template&id=f38be15c&scoped=true"
import script from "./WebView.vue?vue&type=script&lang=js"
export * from "./WebView.vue?vue&type=script&lang=js"

import "./WebView.vue?vue&type=style&index=0&id=f38be15c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f38be15c"]])

export default __exports__